import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateClaimStatus, type IUpdateClaimStatusParams } from '@/services/admin';

export function useUpdateClaimStatus() {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (params: IUpdateClaimStatusParams) => updateClaimStatus(params),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['adminClaims'] });
      void queryClient.invalidateQueries({ queryKey: ['dashboard'] });
    },
  });

  return {
    updateStatus: mutation.mutateAsync,
    updateStatusSync: mutation.mutate,
    isPending: mutation.isPending,
    loading: mutation.isPending,
    error: mutation.error?.message ?? null,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    reset: mutation.reset,
  };
}
